import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { fileUrl } from "@/lib/api";
import { formatDate } from "@/i18n";
import { ArrowLeft } from "lucide-react";

export default function NewsDetail() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/news/${id}`).then((r) => setPost(r.data)).catch(() => setError(true));
  }, [id]);

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center">
        <h1 className="text-2xl font-semibold mb-4">{t("news.notFound")}</h1>
        <Link to="/news" className="text-bordeaux hover:underline">{t("news.backToOverview")}</Link>
      </div>
    );
  }
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-32 text-slate-500">{t("common.loading")}</div>;

  return (
    <article data-testid="news-detail-page" className="max-w-3xl mx-auto px-6 py-20 md:py-28 break-words">
      <Link to="/news" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-bordeaux mb-10">
        <ArrowLeft size={14} /> {t("news.backAll")}
      </Link>
      <div className="text-xs uppercase tracking-[0.3em] text-bordeaux-accent mb-4">
        {formatDate(post.publish_at) || t("news.eyebrow")}
      </div>
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-tight break-words">
        {post.title}
      </h1>
      {post.excerpt && (
        <p className="mt-6 text-xl text-slate-600 leading-relaxed break-words">{post.excerpt}</p>
      )}
      {post.image_path && (
        <div className="mt-10 rounded-sm overflow-hidden border border-slate-200">
          <img src={fileUrl(post.image_path)} alt={post.title} className="w-full h-auto" />
        </div>
      )}
      <div className="mt-10 prose prose-slate max-w-none whitespace-pre-line break-words text-slate-700 leading-relaxed">
        {post.content}
      </div>
    </article>
  );
}
